import {Component, signal, inject, DestroyRef} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {RuleCheckerService} from '../../../../services/store/rule-checker.service';
import {ModalComponent} from '../../../../shared/components/modal/modal.component';
import {StoreBankingSettingsService} from '../../../../services/http/store/store-banking-settings.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

/** Data required to open the banking settings delete modal. */
export interface BankingSettingsDeleteData {
  storeId?: string;
  date: string;
}

/**
 * This component handles deleting banking requirements.
 */
@Component({
  selector: 'app-banking-settings-delete',
  templateUrl: './banking-settings-delete.component.html',
  styleUrls: ['./banking-settings-delete.component.less'],
  imports: [SHARED_IMPORTS]
})
export class BankingSettingsDeleteComponent {
  private storeBankingSettingsService = inject(StoreBankingSettingsService);
  private toastr = inject(ToastrService);
  private ruleCheckerService = inject(RuleCheckerService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** An identifier of a store. */
  readonly storeId = signal<string>(undefined);
  /** The Monday, from which banking requirement should be deleted. */
  readonly date = signal<string>('');

  /** `True` if request to backend is in progress. */
  loading = signal(false);

  static open(modalService: NgbModal, data: BankingSettingsDeleteData): NgbModalRef {
    const modalRef = modalService.open(BankingSettingsDeleteComponent);
    const instance = modalRef.componentInstance as BankingSettingsDeleteComponent;
    instance.storeId.set(data.storeId);
    instance.date.set(data.date);
    return modalRef;
  }

  /**
   * Sends request to backend to delete a banking requirement.
   * @param modalComponent a modal component of banking settings form.
   */
  confirm(modalComponent: ModalComponent): void {
    this.loading.set(true);

    this.storeBankingSettingsService.deleteBanking(this.storeId(), this.date())
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                modalComponent.activeModal.close();
                this.loading.set(false);
                this.toastr.success('Store closed has been successfully deleted');
                this.ruleCheckerService.check();
              },
              error: error => {
                this.loading.set(false);
                this.toastr.error(error.error.message);
              }
            });
  }
}